import styles from './GameCard.module.css';
import { useTheme } from '../contexts/ThemeContext';

function GameCard({ name, available, onClick, color, logo, statusText }) {
    const { theme } = useTheme();
    const cardClasses = `${styles.card} ${available ? styles.available : styles.disabled}`;

    const backgroundColor = available
        ? theme.accent
        : theme.accentHover;

    return (
        <div
            className={cardClasses}
            onClick={available ? onClick : null}
            style={{
                backgroundColor,
                borderColor: theme.light,
                color: theme.textPrimary
            }}
        >
            {logo ? (
                <img
                    src={`/logos/${logo}`}
                    alt={`${name} logo`}
                    className={styles.logo}
                    loading="lazy"
                />
            ) : null}
            <div className={styles.cardName}>{name}</div>
            <div className={styles.cardAvailable}>
                {statusText || (available ? 'Play Now' : 'Coming Soon')}
            </div>
        </div>
    );
}

export default GameCard;
